import { render, staticRenderFns } from "./incident-details.vue?vue&type=template&id=4cbdfea0&scoped=true"
import script from "./incident-details.vue?vue&type=script&lang=js"
export * from "./incident-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbdfea0",
  null
  
)

export default component.exports